<template>
  <div
    ref="dropZone"
    :draggable="editing"
    class="support-category"
    :dropzone="canDrop"
    :class="{ 'drag-over': dragOver, 'dragging-support': !!draggingSupportArticleId, 'dragging-category': !!draggingCategoryId, 'drop-after': dropAfter, 'drop-before': !dropAfter, 'dragging': dragging }"
    @dragstart="dragStart($event)"
    @dragend="dragEnd"
    @drop="drop"
    @dragover.prevent
    @dragenter="dragEnter"
    @dragleave="dragLeave"
  >
    <div class="text-h5 q-mb-md">
      {{ category.name }}
      <q-menu
        touch-position
        context-menu
      >
        <q-list>
          <q-item
            v-close-popup
            clickable
            @click="$emit('create-category', category.displayOrder - 5)"
          >
            <q-item-section avatar>
              <q-icon name="add" />
            </q-item-section>
            <q-item-section>
              New Category
            </q-item-section>
          </q-item>
          <q-item
            v-close-popup
            clickable
            @click="create()"
          >
            <q-item-section avatar>
              <q-icon name="add" />
            </q-item-section>
            <q-item-section>
              New Support Article
            </q-item-section>
          </q-item>

          <q-separator />

          <q-item
            v-close-popup
            clickable
            @click.stop="$emit('edit-category', category)"
          >
            <q-item-section avatar>
              <q-icon name="edit" />
            </q-item-section>
            <q-item-section>
              Edit
            </q-item-section>
          </q-item>

          <q-separator />
          <q-item
            v-close-popup
            clickable
            @click="deleteCategory"
          >
            <q-item-section avatar>
              <q-icon name="delete" />
            </q-item-section>
            <q-item-section>
              Delete Category
            </q-item-section>
          </q-item>
        </q-list>
      </q-menu>
    </div>
    <transition-group
      name="list-complete"
      class="row"
      tag="span"
    >
      <support-article-menu-item
        v-for="supportArticle in category.entries"

        :key="supportArticle.id"

        class="list-complete-item"

        :support-article="supportArticle"

        :editing="editing"

        :dragging-category-id="draggingCategoryId"
        :dragging-support-article-id="draggingSupportArticleId"
        :selected-support-article-ids="selectedSupportArticleId"

        @drag-start-support-article="supportArticleId => $emit('drag-start-support-article', supportArticleId)"
        @drag-end-support-article="(supportArticleId, dropAfter) => $emit('drag-end-support-article', supportArticleId, dropAfter)"
        @edit="supportArticle => edit(supportArticle)"
        @create-support-article="supportArticle => create(supportArticle)"
        @select-support-article="supportArticle => $emit('select-support-article', supportArticle)"
        @delete-support-articles="ids => $emit('delete-support-articles', ids)"

        @change="$emit('change')"
      />
    </transition-group>
    <support-article-form
      ref="supportArticleForm"
      :inline="true"
      @change="$emit('change')"
    />
  </div>
</template>

<script>
import SupportCategory from 'src/models/support/SupportCategory'
import SupportArticleMenuItem from 'src/modules/admin/support/SupportArticleMenuItem'
import SupportArticleForm from 'src/modules/admin/support-article/SupportArticleForm'

export default {
  name: 'SupportCategoryMenuItem',
  components: { SupportArticleMenuItem, SupportArticleForm },
  props: {
    category: {
      type: Object,
      required: false,
      default: null
    },
    draggingCategoryId: {
      type: Number,
      required: false,
      default: null
    },
    draggingSupportArticleId: {
      type: Number,
      required: false,
      default: null
    },
    selectedSupportArticleId: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    editing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['create-category', 'edit-category', 'drag-start-support-article', 'drag-end-support-article', 'select-support-article', 'delete-support-articles', 'change', 'drag-start-category', 'drag-end-category'],
  data () {
    return {
      dragOver: 0,
      dragging: false,
      dropAfter: false
    }
  },
  computed: {
    canDrop () {
      return this.category.id !== this.draggingCategoryId
    }
  },
  methods: {
    dragStart (event) {
      this.$emit('drag-start-category', this.category.id)

      // Use set timeout because we want the drag bitmap to be the version prior to adding the dragging class
      setTimeout(() => { this.dragging = true }, 0)
    },
    dragEnd () {
      this.$emit('drag-start-category', null)
      this.dragging = false
    },
    drop () {
      if (!this.canDrop) return

      this.$emit('drag-end-category', this.category.id, this.dropAfter)
      this.dragOver = 0
    },
    dragEnter (e) {
      if (!this.canDrop) return

      // Determine if we are above or below center, drop before or after support
      const rect = this.$refs.dropZone.getBoundingClientRect()
      if ((e.clientY - rect.top) < (rect.bottom - rect.top) / 2) {
        this.dropAfter = false
      } else {
        this.dropAfter = true
      }

      this.dragOver += 1
    },
    dragLeave () {
      if (!this.canDrop) return

      this.dragOver -= 1
    },
    create (supportArticle) {
      this.$refs.supportArticleForm.show(null, { supportCategory: supportArticle?.supportCategory || this.category, displayOrder: supportArticle?.displayOrder ? supportArticle.displayOrder - 5 : 999999 })
    },
    edit (supportArticle) {
      this.$refs.supportArticleForm.show(supportArticle)
    },
    async deleteCategory () {
      const category = new SupportCategory({ id: this.category.id })
      const { errors } = await category.delete()
      if (errors && errors.length) {
        this.$mh.showErrors(errors)
      } else {
        this.$emit('change')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.support-category {
  &.dragging-category {
    &.drag-over.drop-before {
      border-top: solid 3px #000;
    }
    &.drag-over.drop-after {
      border-bottom: solid 3px #000;
    }
  }
  &.dragging-support {
    &.drag-over {
      border: solid 2px $grey-8;
      opacity: 0.5;
    }
  }
}

.dragging {
  border: solid 2px $grey-5;
  opacity: 0.5;
}

.list-complete-item {
  transition: all 0.5s;
  display: inline-block;
}
.list-complete-enter {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-to {
  opacity: 0;
  transform: translateX(0) translateY(0);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
